const locales = {
  en: {
    titleLocation: 'Your location is set to',
    titleLanguage: 'Your language is set to',
    shopIn: 'Shop in',
    shippingOptions: 'Get shipping options for',
    languageSetTo: 'Language set to',
    continue: 'Continue',
    changeCountryLanguage: 'Change country / language',
    changeLanguage: 'Select language',
    country: 'Country',
    language: 'Language',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    infoCountryNotAvailableForShipping:
      'If your country isn’t listed, it indicates that shipping to that location is currently unavailable.',
  },
  fr: {
    titleLocation: 'Votre emplacement est défini sur',
    titleLanguage: 'Votre langue est définie sur',
    shopIn: 'Acheter en',
    shippingOptions: 'Obtenir les options de livraison pour',
    languageSetTo: 'Langue définie sur',
    continue: 'Continuer',
    changeCountryLanguage: 'Changer de pays / langue',
    changeLanguage: 'Sélectionner la langue',
    country: 'Pays',
    language: 'Langue',
    submit: 'Soumettre',
    back: 'Retour',
    close: 'Fermer',
    infoCountryNotAvailableForShipping:
      'Si votre pays n’est pas répertorié, cela signifie que la livraison à cet endroit n’est actuellement pas disponible.',
  },
  nl: {
    titleLocation: 'Je locatie is ingesteld op',
    titleLanguage: 'Je taal is ingesteld op',
    shopIn: 'Winkel in',
    shippingOptions: 'Verzendopties voor',
    languageSetTo: 'Taal ingesteld op',
    continue: 'Doorgaan',
    changeCountryLanguage: 'Wijzig land / taal',
    changeLanguage: 'Taal selecteren',
    country: 'Land',
    language: 'Taal',
    submit: 'Versturen',
    back: 'Terug',
    close: 'Sluiten',
    infoCountryNotAvailableForShipping:
      'Als uw land niet in de lijst staat, betekent dit dat verzending naar die locatie momenteel niet beschikbaar is.',
  },
  de: {
    titleLocation: 'Ihre Standort ist auf',
    titleLanguage: 'Ihre Sprache ist auf',
    shopIn: 'Shop in',
    shippingOptions: 'Erhalte Versandoptionen für',
    languageSetTo: 'Sprache auf',
    continue: 'Weiter',
    changeCountryLanguage: 'Land / Sprache ändern',
    changeLanguage: 'Sprache wählen',
    country: 'Land',
    language: 'Sprache',
    submit: 'Einreichen',
    back: 'Zurück',
    close: 'Schließen',
    infoCountryNotAvailableForShipping:
      'Wenn Ihr Land nicht aufgeführt ist, bedeutet dies, dass der Versand an diesen Ort derzeit nicht möglich ist.',
  },
  es: {
    titleLocation: 'Tu ubicación está configurada en',
    titleLanguage: 'Tu idioma está configurado en',
    shopIn: 'Comprar en',
    shippingOptions: 'Obtener opciones de envío para',
    languageSetTo: 'Idioma configurado en',
    continue: 'Continuar',
    changeCountryLanguage: 'Cambiar país / idioma',
    changeLanguage: 'Cambiar idioma',
    country: 'País',
    language: 'Idioma',
    submit: 'Enviar',
    back: 'Volver',
    close: 'Cerrar',
    infoCountryNotAvailableForShipping:
      'Si tu país no está en la lista, esto indica que el envío a esa ubicación no está disponible actualmente.',
  },
  it: {
    titleLocation: 'La tua posizione è impostata su',
    titleLanguage: 'La tua lingua è impostata su',
    shopIn: 'Compra in',
    shippingOptions: 'Ottieni opzioni di spedizione per',
    languageSetTo: 'Lingua impostata su',
    continue: 'Continua',
    changeCountryLanguage: 'Cambia paese / lingua',
    changeLanguage: 'Lingua selezionare',
    country: 'Paese',
    language: 'Lingua',
    submit: 'Invia',
    back: 'Indietro',
    close: 'Chiudi',
    infoCountryNotAvailableForShipping:
      'Se il tuo paese non è elencato, significa che la spedizione verso quella località non è attualmente disponibile.',
  },
  pt: {
    titleLocation: 'Sua localização está definida em',
    titleLanguage: 'Seu idioma está definido em',
    shopIn: 'Comprar em',
    shippingOptions: 'Obtenha opções de envio para',
    languageSetTo: 'Idioma definido em',
    continue: 'Continuar',
    changeCountryLanguage: 'Alterar país / idioma',
    changeLanguage: 'Selecionar idioma',
    country: 'País',
    language: 'Idioma',
    submit: 'Enviar',
    back: 'Voltar',
    close: 'Fechar',
    infoCountryNotAvailableForShipping:
      'Se o seu país não estiver listado, isso indica que o envio para esse local não está disponível no momento.',
  },
};

export default locales;
